import React from 'react';
import {
    Button,
    Dialog,
    Portal,
} from '@chakra-ui/react';

export type InfoDialogProps = {
    title: string,
    body: React.ReactNode,
    footer?: React.ReactNode,
    open: boolean,
    setOpen: (v: boolean) => void,
}

export const InfoDialog: React.FC<InfoDialogProps> = ({
    title,
    body,
    footer,
    open,
    setOpen,
}) => (
    <Dialog.Root
        lazyMount
        open={open}
        onOpenChange={(e: { open: boolean; }) => setOpen(e.open)}
        placement="center"
        size="lg"
    >
        <Portal>
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content borderRadius={0}>
                    <Dialog.Header>
                        <Dialog.Title fontSize="2rem">{title}</Dialog.Title>
                    </Dialog.Header>
                    <Dialog.Body>
                        {body}
                    </Dialog.Body>
                    <Dialog.Footer>
                        <Dialog.CloseTrigger>
                            <Button colorScheme="primary">Закрыть</Button>
                        </Dialog.CloseTrigger>
                        {footer}
                    </Dialog.Footer>
                </Dialog.Content>
            </Dialog.Positioner>
        </Portal>
    </Dialog.Root>
);
